import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import "./AdminCreateBlogPost.css";

function AdminCreateBlogPost() {
  const [isExpanded, setIsExpanded] = useState(true);  // New state for expand/collapse


  const jwt_token = localStorage.getItem('jwt_authorization');


  const handleToggleClick = () => {
    setIsExpanded(!isExpanded);  // Toggle the state
  };

  const handleCreate = async () => {
    const jwt_token = localStorage.getItem('jwt_authorization');

    const title = document.getElementById('create-post-title').value || 'Untitled';
    const body = document.getElementById('create-post-body').value || 'No content';
    const tags = document.getElementById('create-post-tags').value || 'No tags';
    const slug = document.getElementById('create-post-slug').value || 'no-slug';

    const newPost = {
      title,
      body,
      tags,
      slug,
      jwt_token
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/blog-post`, newPost);

      if (response.status === 200) {
        console.log('Blog post created:', response.data);
        // flashMessage('success', 'Blog post created successfully');
      }

    } catch (error) {
      console.error('Failed to update:', error);
    }
} 

  return (
    <div className='user-waitlist-container'>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "baseline", justifyContent: "space-between" }} >
        <span className='general-info-label'>Create New Blog Post</span>
        <div onClick={handleToggleClick} style={{ cursor: "pointer" }}>toggle</div>
      </div>
      {isExpanded && (  // Conditionally render the textarea

        <div className='create-blog-post-container'>

            <div className='create-blog-post-form-group'>
              <label htmlFor='title'>Title</label>
              <input type='text' id='create-post-title' name='title' />
            </div>

            <div className='create-blog-post-form-group'>
              <label htmlFor='body'>Body</label>
              <textarea id='create-post-body' name='body' />
            </div>
            <div className='create-blog-post-form-group'>
              <label htmlFor='slug'>Slug</label>
              <input type='text' id='create-post-slug' name='slug' />
            </div>
            <div className='create-blog-post-form-group'>
              <label htmlFor='create-post-tags'>Tags</label>
              <input type='text' id='create-post-tags' name='tags' />
            </div>

          
              <button onClick={handleCreate} className='create-blog-post-form-submit'>Create Blog Post</button>

        </div>
      )}

    </div>
  );
}

export default AdminCreateBlogPost;
